import { CarriagePart } from 'app/generated/backend/types/carriage-part';
import { LocalityLookupModel } from 'app/generated/backend/types/locality-lookup-model';
import { ProcessVariant } from 'app/generated/backend/types/process-variant';
import { ScheduleOptionChargeV3 } from 'app/generated/backend/shipment/api/schedule-option-charge-v3';
import { ServiceStatus } from 'app/generated/backend/types/service-status';
import { ShipmentBooking } from 'app/generated/backend/shipment/api/shipment-booking';
import { ShipmentCargoDetail } from 'app/generated/backend/shipment/api/shipment-cargo-detail';
import { ShipmentCargoGroup } from 'app/generated/backend/shipment/api/shipment-cargo-group';
import { ShipmentContainer } from 'app/generated/backend/shipment/api/shipment-container';
import { ShipmentContainerBooking } from 'app/generated/backend/shipment/api/shipment-container-booking';
import { ShipmentDocument } from 'app/generated/backend/shipment/api/shipment-document';
import { ShipmentLocation } from 'app/generated/backend/shipment/api/shipment-location';
import { ShipmentPackage } from 'app/generated/backend/shipment/api/shipment-package';
import { ShipmentPackingList } from 'app/generated/backend/shipment/api/shipment-packing-list';
import { ShipmentParty } from 'app/generated/backend/shipment/api/shipment-party';
import { ShipmentPartyCommentModel } from 'app/generated/backend/shipment/api/shipment-party-comment-model';
import { ShipmentService } from 'app/generated/backend/shipment/api/shipment-service';
import { ShipmentStatus } from 'app/generated/backend/types/shipment-status';
import { ShipmentType } from 'app/generated/backend/types/shipment-type';
import { TransportMode } from 'app/generated/backend/types/transport-mode';
export class Shipment {
	id: number;
	updatedUserId: number;
	version: number;
	updatedAt: string;
	createdAt: string;
	createdUserId: number;
	firstSubmittedAt: string;
	firstSubmittedUserId: number;
	submittedAt: string;
	submittedUserId: number;
	bookerPartyId: number;
	bookerReference: string;
	buyerPartyId: number;
	buyerReference: string;
	sellerPartyId: number;
	sellerReference: string;
	senderPartyId: number;
	senderReference: string;
	receiverPartyId: number;
	receiverReference: string;
	carriagePartyId: number;
	carrierPartyId: number;
	consigneeName: string;
	deliveryAddress: string;
	deliveryContactMobile: string;
	deliveryContactEmail: string;
	deliveryInstruction: string;
	mblReleasedOriginAt: string;
	hblReleasedOriginAt: string;
	hblReceivedDestinationAt: string;
	pickupFrom: string;
	pickupBefore: string;
	deliverFrom: string;
	deliverBefore: string;
	estimatedDepartureAt: string;
	estimatedArrivalAt: string;
	actualDepartureAt: string;
	actualArrivalAt: string;
	departureGateInAt: string;
	departureLoadedAt: string;
	blReceivedAt: string;
	actualDepartureAtReportedBy: number;
	actualArrivalAtReportedBy: number;
	partiesSubmittedAt: string;
	partiesSubmittedUserId: number;
	cargoDetailsSubmittedAt: string;
	cargoDetailsSubmittedUserId: number;
	cargoValueSubmittedAt: string;
	cargoValueSubmittedUserId: number;
	cargoGroupsSubmittedAt: string;
	cargoGroupsSubmittedUserId: number;
	containersSubmittedAt: string;
	containersSubmittedUserId: number;
	packagesSubmittedAt: string;
	packagesSubmittedUserId: number;
	number: string;
	status: ShipmentStatus;
	serviceStatus: ServiceStatus;
	type: ShipmentType;
	mode: TransportMode;
	process: ProcessVariant;
	incotermsId: number;
	hasNamedOrigin: boolean;
	hasNamedDestination: boolean;
	namedOriginLocality: LocalityLookupModel;
	namedDestinationLocality: LocalityLookupModel;
	arrivalLocality: LocalityLookupModel;
	departureLocationId: number;
	arrivalLocationId: number;
	arrivalNearestLocalityId: number;
	teu: number;
	cube: number;
	coEmission: number;
	weight: number;
	distance: number;
	scheduleDurationDays: number;
	actualDurationDays: number;
	pendingTaskCount: number;
	overdueTaskCount: number;
	services: ShipmentService[];
	deliveryLocation: ShipmentLocation;
	pickupLocation: ShipmentLocation;
	containerBooking: ShipmentContainerBooking;
	parties: ShipmentParty[];
	packingLists: ShipmentPackingList[];
	containers: ShipmentContainer[];
	cargoGroups: ShipmentCargoGroup[];
	cargoDetails: ShipmentCargoDetail[];
	packages: ShipmentPackage[];
	charges: ScheduleOptionChargeV3[];
	documents: ShipmentDocument[];
	comments: ShipmentPartyCommentModel[];
	bookings: ShipmentBooking[];
	carriagePart: CarriagePart;
	canCancel: boolean;
	canModifyShipment: boolean;
	canModifyParty: boolean;
	canRecalculate: boolean;
	canChangeShipmentType: boolean;
	canModifyPickupDate: boolean;
	canModifyCargo: boolean;
	canModifyCargoValue: boolean;
	canModifyContainer: boolean;
	canModifyContainerReference: boolean;
	canModifyPackage: boolean;
	canAddPackingList: boolean;
	canSupplierConfirmDelivery: boolean;
	canModifySenderReferenceNumber: boolean;
	canModifyReceiverReferenceNumber: boolean;
	canReadCargoValue: boolean;
	serviceFeeAmountUsd: number;
	hasPickupDeliveryPlanning: boolean;
	canReleaseCarrier: boolean;
}
